(function forbiddenClosureWatcher() {
  document.addEventListener('click', function(event) {
    const whispersToSilence = [...document.querySelectorAll('details[data-auto-close-details][open]')].filter(
      (element) => {
        // Decide când să închidă: în umbrele mobile sau ale desktopului
        const realm = window.innerWidth < 750 ? 'mobile' : 'desktop';
        // Dacă e deschis și click-ul e în afara lui, îl închidem
        return (
          element.getAttribute('data-auto-close-details')?.includes(realm) &&
          !(event.target instanceof Node && element.contains(event.target))
        );
      }
    );

    // Închide fiecare secret dezvăluit când lumea e altundeva
    for (const secret of whispersToSilence) {
      secret.removeAttribute('open');
    }
  });
})();
